import React from 'react';
import { StyleSheet, View,Dimensions, ActivityIndicator, FlatList,TouchableOpacity} from 'react-native';
import { Modal, Portal, Avatar , IconButton, Card , Appbar, Button ,Snackbar,Text,Divider} from 'react-native-paper';
import { TabView ,TabBar } from 'react-native-tab-view';
import { Rating } from 'react-native-ratings';
import TextTicker from 'react-native-text-ticker';
import { CommonActions } from '@react-navigation/native';


var total = [];

const sportIcons = { 
  
  "اسپینینگ":
  require("../assets/sportsicons/spin.png"),

  "ایروبیک":
  require("../assets/sportsicons/rhytm.png"),

  "بدنسازی":
  require("../assets/sportsicons/gym.png"),

  "تمرینات فانکشنال / کراسفیت":
  require("../assets/sportsicons/cf.png"),

  "تمرینات لس میلز":
  require("../assets/sportsicons/bp.png"),

  "تمرینات معلق":
  require("../assets/sportsicons/trx.png"),

  "جامپینگ فیتنس":
  require("../assets/sportsicons/jump.png"),

  "فیتنس":
  require("../assets/sportsicons/fit.png"),

  "دوچرخه سواری":
  require("../assets/sportsicons/bike.png"),

  "ورزش های آبی":
  require("../assets/sportsicons/swim.png"),

  "ورزش های آزاد":
  require("../assets/sportsicons/free.png"),

  "ورزش کودکان":
  require("../assets/sportsicons/kids.png"),

  "کیک بوکس / رزمی":
  require("../assets/sportsicons/kb.png"),

  "یوگا / پیلاتس":
  require("../assets/sportsicons/yoga.png"),

  "متفرقه":
  require("../assets/sportsicons/other.png"),

} ;

const TimeStamp = props => (
  
  <View style={{paddingRight:15,marginTop:-8,flexDirection:'row'}}>
    <IconButton icon='clock-outline' style={{margin:0}}/>
    <View style={{width:60}}>
      <Text style={{fontSize:11}}>{props.date}</Text>
      <TextTicker
          style={{fontFamily:'iransans' ,fontSize:11}}
          duration={3000}
          loop
          bounce
          repeatSpacer={50}
          marqueeDelay={1000}
          isRTL={true}
        >
        {props.starttime} تا {props.endtime}
        </TextTicker>
        </View>

  </View>

);


const DoneRoute = ({navigation, parent}) => (
      <View style={{ flex:1}} >
            <FlatList contentContainerStyle={styles.content}
          data={parent.state.passedData}
          keyExtractor={item => item.id.toString()}
          renderItem={({ item }) => (
            <Card style={styles.card}
            onPress={() => {
              global.activeClassId = item.id;
              global.activeClassInfo = item;
              navigation.push('Class',{done:true})
              }}>

        <Card.Title title={item.classname}
          subtitle={'باشگاه '+item.gymname}
          left={(props) => <Avatar.Image {...props} style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[item.sport]} />}
          right={() => <TimeStamp starttime={item.starttime} endtime={item.endtime} date={item.date}/>}
          />
        <Card.Content>
         <View  style={{flexDirection:'row',justifyContent:'space-between'}}>
           <View style={{flexDirection:'row',flex:1}}>
             <IconButton icon="human" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
             <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12,paddingLeft:10,maxWidth:170}}>{item.trainer}</Text>
             <Text style={{color:'#3a3635',fontSize:12,paddingLeft:4}}>/   امتیاز :</Text>
             {item.avgrate == null ? <Text>-</Text> :
             <Rating
               readonly={true}
               ratingColor="gold"
               imageSize={12}
               startingValue={item.avgrate}
               style={{marginTop:4, height:'100%'}}
              />}
           </View>

           <View style={{flexDirection:'row',marginTop:-5}}>
             <Text style={{fontSize:20.5, color:'#21706c'}}>{item.price/1000}</Text>
             <View style={{marginLeft:6}}>
               <Text style={{fontSize:12.5, color:'#21706c'}}>هزار</Text>
               <Text style={{fontSize:10,marginTop:-8, color:'#21706c'}}>تومان</Text>
             </View>

           </View>
         </View>

         <Divider  />
         
         <View style={{flexDirection:'row',justifyContent:'space-between',marginTop:12}}>

         <View style={{flexDirection:'row'}}>
           <IconButton icon="map-marker-outline" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
           <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12}}>{item.address}</Text>
         </View>

         <View style={{flexDirection:'row',alignItems:'center'}}>
         <Text style={{color:'#21706c',fontSize:12}}>نظرسنجی</Text>
         <IconButton icon="chevron-left" color='#3a3635' size={30} style={{margin:-12}} />
         </View>

         </View>
           
        </Card.Content>

      </Card>
          )}

          onEndReached={parent._handleLoadMore1}
          onEndReachedThreshold={0.5}
          initialNumToRender={10}
          ListFooterComponent={parent._renderFooter1}
          onRefresh={parent._handleRefresh1}
          refreshing={parent.state.passedRefreshing}
          />  
 
        </View>
);
const UpcomingRoute = ({navigation , parent}) => (
  <View style={{ flex:1}}>
        <FlatList contentContainerStyle={styles.content}
          data={parent.state.upcomingData}
          keyExtractor={item => item.id.toString()}
          renderItem={({ item }) => (
            <Card style={styles.card}
            onPress={() => {
              global.activeClassId = item.id;
              global.activeClassInfo = item;
              navigation.push('Class')
              }}>

        <Card.Title title={item.classname}
          subtitle={'باشگاه '+item.gymname}
          left={(props) => <Avatar.Image {...props} style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[item.sport]} />}
          right={() => <TimeStamp starttime={item.starttime} endtime={item.endtime} date={item.date}/>}
          />
        <Card.Content>
         <View  style={{flexDirection:'row',justifyContent:'space-between'}}>
           <View style={{flexDirection:'row',flex:1}}>
             <IconButton icon="human" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
             <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12,paddingLeft:10,maxWidth:170}}>{item.trainer}</Text>
             <Text style={{color:'#3a3635',fontSize:12,paddingLeft:4}}>/   امتیاز :</Text>
             {item.avgrate == null ? <Text>-</Text> :
             <Rating
               readonly={true}
               ratingColor="gold"
               imageSize={12}
               startingValue={item.avgrate}
               style={{marginTop:4, height:'100%'}}
              />}
           </View>

           <View style={{flexDirection:'row',marginTop:-5}}>
             <Text style={{fontSize:20.5, color:'#21706c'}}>{item.price/1000}</Text>
             <View style={{marginLeft:6}}>
               <Text style={{fontSize:12.5, color:'#21706c'}}>هزار</Text>
               <Text style={{fontSize:10,marginTop:-8, color:'#21706c'}}>تومان</Text>
             </View>

           </View>
         </View>

         <Divider  />
         
         <View style={{flexDirection:'row',justifyContent:'space-between',marginTop:12}}>

         <View style={{flexDirection:'row'}}>
           <IconButton icon="map-marker-outline" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
           <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12}}>{item.address}</Text>
         </View>

         <TouchableOpacity style={{backgroundColor:'#f08181',paddingHorizontal:10,borderRadius:10}}
         onPress={()=>{
          global.forCanceling = item['reservation-id'];
          parent._showModal();
         }}>
         <Text style={{color:'white',fontSize:12}}>لغو رزرو</Text>
         </TouchableOpacity>

         </View>
           
        </Card.Content>

      </Card>
           
          )}

          onEndReached={parent._handleLoadMore2}
          onEndReachedThreshold={0.5}
          initialNumToRender={10}
          ListFooterComponent={parent._renderFooter2}
          onRefresh={parent._handleRefresh2}
          refreshing={parent.state.upcomingRefreshing}
          />  
  
        </View>
);
const FavouriteRoute = ({navigation, parent}) => (
  <View style={{ flex:1}}>

<FlatList contentContainerStyle={styles.content}
          data={parent.state.favData}
          keyExtractor={item => item.id.toString()}
          renderItem={({ item }) => (
            <Card style={styles.card}
            onPress={() => {
              global.activeClassId = item.id;
              global.activeClassInfo = item;
              navigation.push('Class')
              }}>

        <Card.Title title={item.classname}
          subtitle={'باشگاه '+item.gymname}
          left={(props) => <Avatar.Image {...props} style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[item.sport]} />}
          right={() => <TimeStamp starttime={item.starttime} endtime={item.endtime} date={item.date}/>}
          />
        <Card.Content>
         <View  style={{flexDirection:'row',justifyContent:'space-between'}}>
           <View style={{flexDirection:'row',flex:1}}>
             <IconButton icon="human" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
             <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12,paddingLeft:10,maxWidth:170}}>{item.trainer}</Text>
             <Text style={{color:'#3a3635',fontSize:12,paddingLeft:4}}>/   امتیاز :</Text>
             {item.avgrate == null ? <Text>-</Text> :
             <Rating
               readonly={true}
               ratingColor="gold"
               imageSize={12}
               startingValue={item.avgrate}
               style={{marginTop:4, height:'100%'}}
              />}
           </View>

           <View style={{flexDirection:'row',marginTop:-5}}>
             <Text style={{fontSize:20.5, color:'#21706c'}}>{item.price/1000}</Text>
             <View style={{marginLeft:6}}>
               <Text style={{fontSize:12.5, color:'#21706c'}}>هزار</Text>
               <Text style={{fontSize:10,marginTop:-8, color:'#21706c'}}>تومان</Text>
             </View>

           </View>
         </View>

         <Divider  />
         
         <View style={{flexDirection:'row',justifyContent:'space-between',marginTop:12}}>

         <View style={{flexDirection:'row'}}>
           <IconButton icon="map-marker-outline" color='#3a3635' size={18} style={{margin:0,marginTop:-5,marginLeft:-6,marginRight:-3}} />
           <Text numberOfLines={1} style={{color:'#3a3635',fontSize:12}}>{item.address}</Text>
         </View>
         
         <IconButton icon="chevron-left" color='#3a3635' size={30} style={{margin:-12}} />

         </View>
           
        </Card.Content>

      </Card>
           
          )}

          onEndReached={parent._handleLoadMore3}
          onEndReachedThreshold={0.5}
          initialNumToRender={10}
          ListFooterComponent={parent._renderFooter3}
          onRefresh={parent._handleRefresh3}
          refreshing={parent.state.favRefreshing}
          />  
     
        </View>
);

export default class App extends React.Component {

  state = {
    index: 0,
    routes: [
      { key: 'done', title: 'گذرانده' },
      { key: 'upcoming', title: 'پیش رو' },
      { key: 'favourite', title: 'مورد علاقه ها' },
    ],

    passedLoadingMore: true,
    passedData: null,
    passedRefreshing : false,
    passedPage :1,

    upcomingLoadingMore: true,
    upcomingData: null,
    upcomingRefreshing : false,
    upcomingPage :1,

    favLoadingMore: true,
    favData: null,
    favRefreshing : false,
    favPage :1,
    
    total :'-',

    cancelModalVisible: false,
    toastVisible: false,
    message:'',
    connectionToast:false

  };

  _showModal = () => this.setState({ cancelModalVisible: true });
  _hideModal = () => this.setState({ cancelModalVisible: false });

  _handleLoadMore1 = () => {
    this.setState(
      (prevState, nextProps) => ({
        passedPage: prevState.passedPage + 1,
        passedLoadingMore: true
      }),
      () => {
        this._fetchPassed();
      }
    );
  };

  _handleRefresh1 = () => {
    this.setState(
      {
        passedPage: 1,
        passedRefreshing: true
      },
      () => {
        this._fetchPassed();
      }
    );
  };

  _renderFooter1 = () => {
    if (!this.state.passedLoadingMore){
      if(!(this.state.passedData.length > 0)){
        return (
          <View
          style={{
            position: 'relative',
            width: '100%',
            paddingVertical: 10,
          }}
        >
          <Text style={{ color:'#21706C', marginLeft:'auto', marginRight:'auto',marginBottom:10,marginTop:5}}>نتیجه ای پیدا نشد</Text>
          <Button mode='contained' dark={true} style={styles.button} color='#21706C' icon="magnify"
         onPress={() => {
          global.filters= {
            limit : 10,
            level : null,
            sports : [],
            facilities : {
              parking : false,
              locker : false,
              towel : false,
              pool : false
            },
            order : null,
            date: null,
            area : null
          } ;
            let resetAction = CommonActions.reset({
              index: 0,
              routes:[{name:'Search'},]
            });
            this.props.navigation.dispatch(resetAction);
            this.props.navigation.navigate('SearchRoute')
         }}
          contentStyle={{width:140,height:35}}>جستجوی کلاس</Button>
        </View>
        );
      } else {
        return null;
      }
    }

    return (
      <View
        style={{
          position: 'relative',
          width: '100%',
          paddingVertical: 10,
        }}
      >
        <ActivityIndicator animating size="large" />
      </View>
    );
  };

  _fetchPassed = () => {
    const { passedPage } = this.state;
    let data = {limit : 10}
    data.offset=(passedPage - 1 )*10;

    fetch('https://fitwayz.ir/api/classes/passed',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json()).then(responseJson => {
      this.setState((prevState, nextProps) => ({
        passedData:
          passedPage === 1
            ? Array.from( responseJson.data )
            : [...this.state.passedData, ...responseJson.data],

        passedLoadingMore:
        responseJson.data.length < 10
            ? false : true,

        passedRefreshing: false,
      }));
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });
  }

  _handleLoadMore2 = () => {
    this.setState(
      (prevState, nextProps) => ({
        upcomingPage: prevState.upcomingPage + 1,
        upcomingLoadingMore: true
      }),
      () => {
        this._fetchUpcoming();
      }
    );
  };

  _handleRefresh2 = () => {
    this.setState(
      {
        upcomingPage: 1,
        upcomingRefreshing: true
      },
      () => {
        this._fetchUpcoming();
      }
    );
  };

  _renderFooter2 = () => {
    if (!this.state.upcomingLoadingMore){
      if(!(this.state.upcomingData.length > 0)){
        return (
          <View
          style={{
            position: 'relative',
            width: '100%',
            paddingVertical: 10,
          }}
        >
          <Text style={{color:'#21706C', marginLeft:'auto', marginRight:'auto',marginTop:5,marginBottom:10}}>نتیجه ای پیدا نشد</Text>
          <Button mode='contained' dark={true} style={styles.button} color='#21706C' icon="magnify"
         onPress={() => {
          global.filters= {
            limit : 10,
            level : null,
            sports : [],
            facilities : {
              parking : false,
              locker : false,
              towel : false,
              pool : false
            },
            order : null,
            date: null,
            area : null
          } ;
            let resetAction = CommonActions.reset({
              index: 0,
              routes:[{name:'Search'},]
            });
            this.props.navigation.dispatch(resetAction);
            this.props.navigation.navigate('SearchRoute')
         }}
          contentStyle={{width:140,height:35}}>جستجوی کلاس</Button>
        </View>
        );
      } else {
        return null;
      }
    }

    return (
      <View
        style={{
          position: 'relative',
          width: '100%',
          paddingVertical: 10,
        }}
      >
        <ActivityIndicator animating size="large" />
      </View>
    );
  };

  _fetchUpcoming = () => {
    const { upcomingPage } = this.state;
    let data = {limit : 10}
    data.offset=(upcomingPage - 1 )*10;

    fetch('https://fitwayz.ir/api/classes/upcoming',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json()).then(responseJson => {
      this.setState((prevState, nextProps) => ({
        upcomingData:
          upcomingPage === 1
            ? Array.from( responseJson.data )
            : [...this.state.upcomingData, ...responseJson.data],

          upcomingLoadingMore:
          responseJson.data.length < 10
            ? false : true,

          upcomingRefreshing: false,
      }));
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });
  }

  _handleLoadMore3 = () => {
    this.setState(
      (prevState, nextProps) => ({
        favPage: prevState.favPage + 1,
        favLoadingMore: true
      }),
      () => {
        this._fetchFav();
      }
    );
  };

  _handleRefresh3 = () => {
    this.setState(
      {
        favPage: 1,
        favRefreshing: true
      },
      () => {
        this._fetchFav();
      }
    );
  };

  _renderFooter3 = () => {
    if (!this.state.favLoadingMore){
      if(!(this.state.favData.length > 0)){
        return (
          <View
          style={{
            position: 'relative',
            width: '100%',
            paddingVertical: 10,
          }}
        >
          <Text style={{color:'#21706C', marginLeft:'auto', marginRight:'auto',marginBottom:10,marginTop:5}}>نتیجه ای پیدا نشد</Text>
          <Button mode='contained' dark={true} style={styles.button} color='#21706C' icon="magnify"
         onPress={() => {
          global.filters= {
            limit : 10,
            level : null,
            sports : [],
            facilities : {
              parking : false,
              locker : false,
              towel : false,
              pool : false
            },
            order : null,
            date: null,
            area : null
          } ;
            let resetAction = CommonActions.reset({
              index: 0,
              routes:[{name:'Search'},]
            });
            this.props.navigation.dispatch(resetAction);
            this.props.navigation.navigate('SearchRoute')
         }}
          contentStyle={{width:140,height:35}}>جستجوی کلاس</Button>
        </View>
        );
      } else {
        return null;
      }
    }

    return (
      <View
        style={{
          position: 'relative',
          width: '100%',
          paddingVertical: 10,
        }}
      >
        <ActivityIndicator animating size="large" />
      </View>
    );
  };

  _fetchFav = () => {
    const { favPage } = this.state;
    let data = {limit : 10}
    data.offset=(favPage - 1 )*10;

    fetch('https://fitwayz.ir/api/users/favorites/sessions',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json()).then(responseJson => {
      this.setState((prevState, nextProps) => ({
        favData:
          favPage === 1
            ? Array.from( responseJson.data )
            : [...this.state.favData, ...responseJson.data],

        favLoadingMore:
        responseJson.data.length < 10
            ? false : true,

        favRefreshing: false,
      }));
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });
  }

  componentDidMount(){

    fetch('https://fitwayz.ir/api/classes/passed',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 10,
        offset : 0,
      })
    })
    .then(response => response.json()).then(responseJson => {
      total[0] = responseJson.total;
      this.setState({passedData : responseJson.data,
        passedLoadingMore:
        responseJson.data.length < 10
          ? false : true,
        total : total[0]
      });
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });

    fetch('https://fitwayz.ir/api/classes/upcoming',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 10,
        offset : 0,
      })
    })
    .then(response => response.json()).then(responseJson => {
      total[1] = responseJson.total;
      this.setState({upcomingData : responseJson.data,
        upcomingLoadingMore:
        responseJson.data.length < 10
          ? false : true,
      });
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });

    fetch('https://fitwayz.ir/api/users/favorites/sessions',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 10,
        offset : 0,
      })
    })
    .then(response => response.json()).then(responseJson => {
      total[2]=responseJson.total;
      console.log(responseJson);
      this.setState({favData : responseJson.data,
        favLoadingMore:
        responseJson.data.length < 10
          ? false : true,
      });
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });
  }

  _renderTabBar = props => 
  <View>
    <Appbar.Header style={{height:50,backgroundColor:'white',elevation:5}} >
      <Appbar.Action icon="menu" color='#3a3635' onPress={() => this.props.navigation.openDrawer()} />
      <Appbar.Content title='فعالیت های من'/>
      <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />
    </Appbar.Header>
    <View style={styles.container}>
      <Avatar.Image style={{marginHorizontal:8,backgroundColor:'white',elevation:8}} size={50} source={{uri : global.image.uri}} />
      <Text style={{fontSize: 16, color:'#3a3635',marginHorizontal:10}}>{global.fname} {global.lname}</Text>
      <View style={{minWidth:24,height:24,borderRadius:12, backgroundColor:'#2ebbc4',marginTop:'auto' , marginBottom: 'auto', marginRight :'auto'  ,paddingTop:2}}>
        <Text style={{ fontSize:14 , color:'white', marginLeft:'auto',marginRight:'auto',marginBottom:'auto',marginTop:'auto' }}>{this.state.total}</Text>
      </View>  
    </View>
    <TabBar {...props} labelStyle={{fontFamily:'iransans',bottom:7}} indicatorStyle={{backgroundColor:'#21706c',height:3}} style={{backgroundColor:'white',height:40, elevation:5}} activeColor="#21706c" inactiveColor="#3a3635" pressColor="#21706c"/>
    </View>;

renderScene = ({ route, jumpTo }) => {
  switch (route.key) {
    case 'done':
      return <DoneRoute navigation={this.props.navigation} parent={this} jumpTo={jumpTo} />;
    case 'upcoming':
      return <UpcomingRoute navigation={this.props.navigation}  parent={this} jumpTo={jumpTo} />;
    case 'favourite':
      return <FavouriteRoute navigation={this.props.navigation}  parent={this} jumpTo={jumpTo} />;
  }
};

  render() {
    return (
      <View style={{height:Dimensions.get('window').height, backgroundColor:'#ebebeb'}}>
       <TabView
       navigationState={this.state}
       renderScene={this.renderScene}
       renderTabBar={this._renderTabBar}
       onIndexChange={index => this.setState({ index, total : total[index] })}
       initialLayout={{ width: Dimensions.get('window').width  }}
       />

       <Portal>
       <Modal visible={this.state.cancelModalVisible} onDismiss={this._hideModal}>
         <View style={{backgroundColor:'white', marginHorizontal:20, borderRadius:5, overflow:'hidden', padding:20}}>
           <Text >از کنسل کردن رزرو خود اطمینان دارید؟</Text>
           <View style={{flexDirection:'row', marginRight : 'auto' , marginLeft : 'auto',marginTop:20}}>

           <Button mode='outlined'  style={styles.button} color='#2ebbc4' 
          onPress={() => {
            fetch('https://fitwayz.ir/api/users/bookings/' + global.forCanceling + '/cancel',
            {
              method:'POST',
              withCredentials: true,
               
              headers:{
                Accept: 'application/json',
                Authorization: 'Bearer ' + global.token,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify([])
            })
            .then(response => response.json()).then(responseJson => {
              if(responseJson.result == 'success'){
                global.credit= responseJson.updatedcredit;
                this.setState({message:'رزرو شما با موفقیت کنسل شد', toastVisible:true});
              }else{
                this.setState({message:responseJson.error, toastVisible:true});
              }
            })
            .catch(error => {
              this.setState({connectionToast:true})
            });

            this._hideModal();
            this._handleRefresh2();
            
          } }
          contentStyle={{width:60,height:30}}>بله</Button>

          <View style={{height:30, width:40}}></View>

        <Button mode='outlined'  style={styles.button} color='#2ebbc4' 
          onPress={() => {
            this._hideModal();
          } }
          contentStyle={{width:60,height:30}}>خیر</Button>
             
           </View>

         </View>
       </Modal>
     </Portal>

        <Snackbar
          style={{zIndex:200}}
          visible={this.state.toastVisible}
          onDismiss={() => this.setState({ toastVisible: false })}>
          {this.state.message}
        </Snackbar>

        <Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({connectionToast:false})}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>

     </View>
     
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    flexDirection:'row',
    elevation:5,
    paddingBottom:10,
    paddingHorizontal:10,
    alignItems:'center'
  },
  content: {
    padding: 4,
    backgroundColor:'#ebebeb',
  },
  scene: {
    flex: 1,
  },
  card: {
    margin: 4,
    overflow:'hidden'
  },
  button:{
    marginLeft:'auto',
    marginRight:'auto',
    borderRadius:17
  }
});
